import { isMeterListTodo } from "../../../../../utils/isMeterList";

/** Return button text for Generate Documents button, according to `todoLabel`. */
export function getGenerateDocumentsButtonText(todoLabel: string) {
  if (isMeterListTodo(todoLabel)) {
    return "Zählerliste generieren";
  }
  return "Meldeunterlagen erstellen";
}
